import React, { Component, createRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { debounce } from "lodash";
import Button from "../../components/Button";
import { Toolbar, ToolbarGroup } from "../../components/Toolbar";
import { emailTemplatesList, openModal } from "../../actions";
import { history } from "../../history";

export class ListEmailTemplateToolbar extends Component {
  constructor(props) {
    super(props);
    this.openCreateModal = this.openCreateModal.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.search = debounce(this.search.bind(this), 300);
    this.searchRef = createRef();
  }

  componentDidMount() {
    if (this.searchRef?.current) {
      this.searchRef.current.focus();
      this.searchRef.current.selectionStart =
        this.searchRef.current.selectionEnd =
          this.searchRef.current.value.length;
    }
  }

  onSearch(e) {
    const searchTerm = e.currentTarget.value;
    this.search(searchTerm);
  }

  search(searchTerm) {
    this.props.emailTemplatesList(
      this.props.accountId,
      {
        name: searchTerm,
      },
      true
    );
    history.push(
      `${window.location.pathname}?name=${encodeURIComponent(searchTerm)}`
    );
  }

  openCreateModal() {
    const { accountId } = this.props;

    this.props.openModal("create-email-template", {
      accountId,
    });
  }

  render() {
    const { searchTerm } = this.props;

    return (
      <Toolbar>
        <ToolbarGroup>
          <input
            ref={this.searchRef}
            placeholder="Search"
            style={{ width: "100%" }}
            onChange={this.onSearch}
            defaultValue={searchTerm}
          />
        </ToolbarGroup>

        <ToolbarGroup width="160px" align="right">
          <Button onClick={this.openCreateModal}>Create Template</Button>
        </ToolbarGroup>
      </Toolbar>
    );
  }
}

ListEmailTemplateToolbar.propTypes = {
  openModal: PropTypes.func.isRequired,
};

// Connect state data
function mapStateToProps(state) {
  const {
    emailTemplate,
    unsavedChanges,
    showHtml,
    showCss,
    showData,
    showPreview,
  } = state.emailTemplateEditor;

  return {
    emailTemplate,
    unsavedChanges,
    showHtml,
    showCss,
    showData,
    showPreview,
  };
}

// Connect actions
export default connect(mapStateToProps, {
  emailTemplatesList,
  openModal,
})(ListEmailTemplateToolbar);
